/**
 * Initializes scroll-based reveal animations for elements matching a given selector.
 *
 * Adds a specified CSS class to elements when they enter the viewport based on a customizable threshold.
 * Useful for triggering entry animations such as fade-in, slide-up, etc., as users scroll the page.
 *
 * @param {Object} options - Configuration options for the scroll animation.
 * @param {string} [options.selector='.js-scroll'] - CSS selector for target elements.
 * @param {string} [options.visibleClass='is-visible'] - Class to add when element becomes visible.
 * @param {number} [options.threshold=1.4] - Viewport threshold divisor to trigger animation earlier or later.
 * @param {boolean} [options.once=true] - Whether to run the animation only once per element.
 *
 * NOTE to use:
 *
 * // Default Animation
 * scrollEntryAnimation();
 *
 * OR
 *
 * // With another selector and class
 * scrollEntryAnimation({
 *  selector: '.fade-in-on-scroll',
 *  visibleClass: 'fade-in',
 *  threshold: 1.2,
 * });
 *
 * OR
 *
 * // For continuous animation (does not remove listener)
 * scrollEntryAnimation({
 *  selector: '.repeat-animation',
 *  visibleClass: 'is-visible',
 *  threshold: 1.1,
 *  once: false,
 * });
 *
 */
export function scrollEntryAnimation(options) {
    var optionArray = Array.isArray(options) ? options : [options];
    optionArray.forEach(function (_a) {
        var _b = _a.selector, selector = _b === void 0 ? '.animate-entry' : _b, _c = _a.visibleClass, visibleClass = _c === void 0 ? 'is-visible' : _c, _d = _a.threshold, threshold = _d === void 0 ? 30 : _d, _e = _a.once, once = _e === void 0 ? true : _e;
        var scrollElements = document.querySelectorAll(selector);
        scrollElements.forEach(function (el, i) {
            el.style.setProperty('--delay', "".concat((i + 1) * 0.15, "s"));
        });
        // const elementInView = (el: HTMLElement, divisor: number): boolean => {
        //   const elementTop = el.getBoundingClientRect().top;
        //   return elementTop <= window.innerHeight / divisor;
        // };
        var elementInView = function (el, divisor) {
            var top = el.getBoundingClientRect().top;
            var trigger = window.innerHeight * divisor; // 1 = base da viewport
            return top <= trigger;
        };
        var displayScrollElement = function (el) {
            el.classList.add(visibleClass);
        };
        var handleScroll = function () {
            scrollElements.forEach(function (el) {
                if (elementInView(el, threshold) && !el.classList.contains(visibleClass)) {
                    displayScrollElement(el);
                }
            });
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
    });
}
